import { useParams, Navigate } from "react-router-dom";

export const NavigateWithId = (props) => {
    const { id } = useParams();
    const url = props.to.replace(':id', id)
    return <Navigate to={url} />;
};